import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc36f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "provenance" }
const _hoisted_2 = {
  key: 0,
  class: "accordion"
}
const _hoisted_3 = ["href"]

import { ChevronDownIcon, ChevronUpIcon, ExternalLinkIcon } from '@heroicons/vue/solid';
import { ref } from 'vue';

export interface Record {
    label: string;
    link?: string;
    value: string;
  }

  interface ProvenanceProps {
    records: Record[];
  }


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDetails',
  props: {
    records: {}
  },
  setup(__props: any) {



const accordionOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "view-details-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (accordionOpen.value = !accordionOpen.value))
    }, [
      _createTextVNode(" + Details "),
      (!accordionOpen.value)
        ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
            key: 0,
            class: "chevron"
          }))
        : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
            key: 1,
            class: "chevron"
          }))
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (accordionOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (record.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: idx,
                        href: record.link,
                        target: "_blank"
                      }, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(record.label) + " ", 1),
                          (record.link)
                            ? (_openBlock(), _createBlock(_unref(ExternalLinkIcon), {
                                key: 0,
                                class: "link-icon"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(record.value), 1)
                      ], 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("div", {
                        key: Number(idx) * 10
                      }, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(record.label) + " ", 1),
                          (record.link)
                            ? (_openBlock(), _createBlock(_unref(ExternalLinkIcon), {
                                key: 0,
                                class: "link-icon"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(record.value), 1)
                      ]))
                ], 64))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})